import { render, staticRenderFns } from "./pushchatsetid.vue?vue&type=template&id=6b52a8b5&scoped=true"
import script from "./pushchatsetid.vue?vue&type=script&lang=js"
export * from "./pushchatsetid.vue?vue&type=script&lang=js"
import style0 from "./pushchatsetid.vue?vue&type=style&index=0&id=6b52a8b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b52a8b5",
  null
  
)

export default component.exports